import { render, staticRenderFns } from "./PixKeyDetails.vue?vue&type=template&id=2374af37&"
import script from "./PixKeyDetails.vue?vue&type=script&lang=js&"
export * from "./PixKeyDetails.vue?vue&type=script&lang=js&"
import style0 from "./PixKeyDetails.vue?vue&type=style&index=0&id=2374af37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports